export default __webpack_public_path__ + "static/media/ChallengeComplete.3a6e575a.svg";